import {
  Component,
  inject,
  input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { MatTooltip } from '@angular/material/tooltip';
import { FormModeService } from '../../services/form-mode.service';
import { AiSuggestionStateService } from './ai-suggestion.state';

@Component({
  selector: 'procure-ai-suggestion',
  templateUrl: './ai-suggestion.component.html',
  styleUrl: './ai-suggestion.component.scss',
  imports: [MatSlideToggle, MatIcon, MatStepper, MatStep, MatTooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class AiSuggestion {
  readonly aiUpdates = input<{
    lastUpdated: Date;
    updates: string[];
  } | null>(null);

  protected readonly formModeService = inject(FormModeService);
  protected readonly state = inject(AiSuggestionStateService);

  disableUpdates(event: MatSlideToggleChange): void {
    this.state.disabled.set(!event.checked);
  }
}
